import dayjs from "dayjs";
import { HeaderWrapper } from "./Footer.style";
import { MuiTypography } from "../typography/MuiTypography";

export const Footer = () => {
  return (
    <footer role="contentinfo">
      <HeaderWrapper>
        <MuiTypography
          id="Footer-Copyright-Text"
          variant="h3"
          className="label"
          component="div"
        >
          {`© ${dayjs().year()} ManpowerGroup All Rights Reserved.`}
        </MuiTypography>
      </HeaderWrapper>
    </footer>
  );
};
